module.exports = __webpack_public_path__ + "static/media/pulsidBracelet.d56adf13.png";